import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'
// 数字滚动
var istrue = true;
var s = $(window).scrollTop();
if (s > $(".section1").offset().top - $(".section1 .section-title").height() - $(".section1 .content").height() - $("header").height() && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
$(window).on("scroll",
function() {
   var s = $(window).scrollTop();
    if (s > $(".section1").offset().top - $(".section1 .section-title").height() - $(".section1 .content").height() - $("header").height() && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
})


var swiper2 = new Swiper(".section2 .mySwiper", {
    navigation: {
        nextEl: ".section2 .swiper-button-next",
        prevEl: ".section2 .swiper-button-prev",
    },
    spaceBetween: '1.875%',
    slidesPerView: 2.8,
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            spaceBetween: '1.875%',
            slidesPerView: 2.8,
        },
        768: {  //当屏幕宽度小于等于1280
            spaceBetween: '1.875%',
            slidesPerView: 1.8,
        },
        320: {  //当屏幕宽度小于等于320
            spaceBetween: 0,
            slidesPerView: 1,
        }
    }, 
});

var swiper5 = new Swiper(".section5 .mySwiper", {
    navigation: {
        nextEl: ".section5 .swiper-button-next",
        prevEl: ".section5 .swiper-button-prev",
    },
    spaceBetween: '1.875',
    slidesPerView: 4,
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            spaceBetween: '1.6875%',
            slidesPerView: 4,
        },
        768: {  //当屏幕宽度小于等于1280
            spaceBetween: '1.6875%',
            slidesPerView: 3,
        },
        320: {  //当屏幕宽度小于等于320
            spaceBetween: 0,
            slidesPerView: 1,
        }
    }, 
});
$(".introduce").eq(0).addClass('active');
$(".introduce").eq(0).find("p").css("display","block");
$(".introduce").click(function() {
    
    if($(this).hasClass("active")) {
        // $(this).find("p").slideUp();
        // $(this).removeClass("active");
    }else {
        $(".introduce").removeClass("active");
        $(".introduce p").slideUp();
        $(this).find("p").slideDown();
        $(this).addClass("active");
    }
})